import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import {
  Card,
  CardContent,
  Chip,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";

// Extend the Window interface to include the eBay Partner Network variable used by
// the eBay Smart Tools script. This avoids TypeScript errors when assigning to
// window._epn in the client-side effect below.
declare global {
  interface Window {
    _epn?: { campaign?: number };
  }
}


const teamColors: { [id: string]: string[] } = {
  TBR: ["#02285C", "#90BDE7", "#FFFFFF"],
  BAL: ["#F25D23", "#000000", "#FFFFFF"],
  NYY: ["#132448", "#FFFFFF", "#FFFFFF"],
  BOS: ["#BD3039", "#0D2B56", "#FFFFFF"],
  TOR: ["#134A8E", "#E8291C", "#FFFFFF"],
  CLE: ["#E31937", "#002B5C", "#FFFFFF"],
  KCR: ["#004687", "#FFFFFF", "#FFFFFF"],
  DET: ["#0C2C56", "#FFFFFF", "#FFFFFF"],
  CHW: ["#000000", "#BFBFBF", "#FFFFFF"],
  MIN: ["#091F40", "#E31E34", "#FFFFFF"],
  HOU: ["#002D62", "#F4911E", "#FFFFFF"],
  SEA: ["#005C5C", "#0C2C56", "#FFFFFF"],
  TEX: ["#C0111F", "#003278", "#FFFFFF"],
  LAA: ["#BA0021", "#003263", "#C4CED4"],
  ATH: ["#00342C", "#FFB400", "#FFFFFF"],
  WSN: ["#AB0003", "#FFFFFF", "#FFFFFF"],
  NYM: ["#F75500", "#002C6E", "#FFFFFF"],
  MIA: ["#019CD6", "#E51829", "#FFFFFF"],
  PHI: ["#C21D39", "#01396F", "#FFFFFF"],
  ATL: ["#D3042B", "#001D3D", "#FFFFFF"],
  CIN: ["#C6011F", "#000000", "#FFFFFF"],
  PIT: ["#F7BF02", "#000000", "#FFFFFF"],
  CHC: ["#123581", "#E62F2E", "#FFFFFF"],
  MIL: ["#18294C", "#FEC430", "#FFFFFF"],
  STL: ["#BE0A15", "#FDDB00", "#FFFFFF"],
  LAD: ["#005A9D", "#FFFFFF", "#FFFFFF"],
  ARI: ["#C71128", "#00C2CE", "#FFFFFF"],
  SDP: ["#2D221C", "#FFC125", "#FFFFFF"],
  SFG: ["#231F20", "#F4793E", "#E8D8C4"],
  COL: ["#503E80", "#BFC2C9", "#FFFFFF"],
  FA: ["#BFBFBF", "#FFFFFF", "#FFFFFF"],
  "0": ["#BFBFBF", "#FFFFFF", "#FFFFFF"],
};


export default function SprayChart(props: any) {
  //console.log("EbayCards Props:", props);
  const [cardData, setCardData] = useState<any[]>([]);
  useEffect(() => {
    fetch(props.prod ? "https://oriolebird.pythonanywhere.com/cards/" + encodeURIComponent(props.playerData.name) : "/cards/" + encodeURIComponent(props.playerData.name))
      .then((res) => res.json())
      .then((pData) => {
        //console.log("Card Data for ", props.playerData.name, pData);
        setCardData(pData)
      });
    // Check for browser environment
    if (typeof window !== 'undefined') {
      // Configure the global EPN variable
      window._epn = { campaign: 5339131584 };

      // Check if the script already exists to avoid duplicates
      if (!document.querySelector('script[src="https://epnt.ebay.com/static/epn-smart-tools.js"]')) {
        const script = document.createElement('script');
        script.src = 'https://epnt.ebay.com/static/epn-smart-tools.js';
        script.async = true;
        document.body.appendChild(script);
      }
    }
  }, [props.id, props.prod, props.season, props.playerData.name]);

  const temp = Object.keys(props).includes('teamInfoProp')
  if (temp) {
    props.playerInfoProp.common = { teamInfo: props.teamInfoProp }
  }



  return (
    <div>
      <Grid
        container
        justifyContent="center"
        spacing={2}
      >
        <Grid maxWidth="90vw">
          <Box
            sx={{
              maxWidth: "90vw",
              width: "500px",
              border: "#293241 solid 2px",
              backgroundColor: "#FFFFFF",
              height: props.isDesktop ? "570px" : " 100%",
              boxShadow:
                "1px 1px 1px black,2px 2px 1px white,3px 3px 1px black,4px 4px 3px",
            }}
            justifyContent="flex-start"
            alignItems="center"
            display="flex"
            flexDirection="column"
          >
            <div
              style={{
                width: "100%",
                paddingTop: "10px",
                paddingBottom: "10px",
                backgroundColor:
                  props.playerInfoProp.common.teamInfo.MLB_AbbName !== null
                    ? teamColors[props.playerInfoProp.common.teamInfo.MLB_AbbName][0]
                    : teamColors["FA"][0],
              }}
            >
              <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
              >
                <Typography variant="h5">
                  <span
                    style={{
                      color:
                        props.playerInfoProp.common.teamInfo.MLB_AbbName !== null
                          ? teamColors[
                          props.playerInfoProp.common.teamInfo.MLB_AbbName
                          ][1]
                          : teamColors["FA"][1],
                      fontWeight: "bold",
                      fontSize: "25pt",
                      textAlign: "center"
                    }}
                  >
                    Cards for Sale
                  </span>
                </Typography>
              </Grid>
            </div>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0, width: '100%', maxHeight: props.isDesktop ? 500 : "100%", overflowY: 'auto' }}>
              {(props.isDesktop ? cardData : cardData.slice(0, 15)).map((listing, index) => (
                <Card
                  key={index}
                  variant="outlined"
                  sx={{
                    margin: 0,
                    flexShrink: 0,
                    cursor: 'pointer',
                    transition: 'all 0.2s',
                    textDecoration: 'none', // Remove underline
                    color: 'inherit', // Keep original text color
                    '&:hover': {
                      backgroundColor: 'action.hover',
                      boxShadow: 1,
                      textDecoration: 'none' // Ensure no underline on hover
                    }
                  }}
                  component="a"
                  href={listing.url+'&mkcid=1&mkrid=711-53200-19255-0&siteid=0&campid=5339131584&toolid=10001&customid=link&mkevt=1'}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={(e) => e.stopPropagation()}
                >
                  <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2, p: 0, px: 1, '&:last-child': { pb: 0 } }}>
                    {/* Image */}
                    <img
                      src={listing.image_url}
                      alt={listing.title}
                      style={{
                        width: 60,
                        height: 60,
                        objectFit: 'cover',
                        borderRadius: 4
                      }}
                    />

                    {/* Content */}
                    <Box sx={{ flex: 1, minWidth: 0, py: 0.5 }}>
                      <Typography variant="body2" noWrap sx={{ mb: 0.5, textDecoration: 'none' }}>
                        {listing.title}
                      </Typography>

                      <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap' }}>
                        {/* Type Badge */}
                        <Chip
                          label={listing.type === 'Buy It Now' ? 'Buy on eBay' : 'eBay Auction'}
                          color={listing.type === 'Buy It Now' ? 'primary' : 'secondary'}
                          size="small"
                          sx={{ height: 24, textDecoration: 'none' }}
                        />

                        {/* Price */}
                        <Typography variant="body2" fontWeight="bold" sx={{ textDecoration: 'none' }}>
                          {listing.type === 'Buy It Now'
                            ? `$${listing.price}`
                            : `Bid: $${listing.current_bid_price}`
                          }
                        </Typography>
                      </Box>
                    </Box>
                  </CardContent>
                </Card>
              ))}
            </Box>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
}